/* eslint-disable -- React Compiler rules (react-hooks v6) flagged by external linter are not enabled in this project's CRA toolchain (react-hooks 5.2.0); false positives on event-handler setState */
import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

const TEMPLATES = [
  { id: "reservation", label: "Reservierungsbestätigung", desc: "Wird automatisch nach erfolgreicher Reservierung gesendet" },
  { id: "welcome", label: "Willkommens-E-Mail", desc: "Wird automatisch bei neuer Mitglieder-Registrierung gesendet" },
  { id: "approval", label: "Genehmigungs-E-Mail", desc: "Wird automatisch bei Mitgliedschafts-Genehmigung gesendet" },
];

export function EmailTab({ api }) {
  const [selectedTemplate, setSelectedTemplate] = useState("reservation");
  const [previewHtml, setPreviewHtml] = useState("");
  const [previewSubject, setPreviewSubject] = useState("");
  const [testEmail, setTestEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sending, setSending] = useState(false);

  const loadPreview = async (templateType) => {
    setLoading(true);
    try {
      const res = await api.post("/email/preview", { template_type: templateType });
      setPreviewHtml(res.data.html);
      setPreviewSubject(res.data.subject);
    } catch (err) {
      toast.error("Vorschau konnte nicht geladen werden");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPreview(selectedTemplate);
  }, [selectedTemplate]);

  const sendTestEmail = async () => {
    if (!testEmail) {
      toast.error("Bitte E-Mail-Adresse eingeben");
      return;
    }
    setSending(true);
    try {
      await api.post("/email/test", { template_type: selectedTemplate, to_email: testEmail });
      toast.success(`Test-E-Mail wurde an ${testEmail} gesendet`);
    } catch (err) {
      toast.error(err.response?.data?.detail || "E-Mail konnte nicht gesendet werden");
    } finally {
      setSending(false);
    }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold uppercase tracking-tight" style={{ fontFamily: 'Oswald' }}>
          E-Mail Vorschau & Test
        </h2>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="space-y-3">
          <h3 className="text-sm font-bold uppercase tracking-wider text-muted-foreground">Template auswählen</h3>
          {TEMPLATES.map(t => (
            <button
              key={t.id}
              onClick={() => setSelectedTemplate(t.id)}
              className={`w-full text-left p-4 border transition-colors ${
                selectedTemplate === t.id 
                  ? 'border-primary bg-primary/10' 
                  : 'border-white/10 hover:border-white/20'
              }`}
              data-testid={`email-template-${t.id}`}
            >
              <p className="font-semibold text-sm">{t.label}</p>
              <p className="text-xs text-muted-foreground mt-1">{t.desc}</p>
            </button>
          ))}

          <div className="border-t border-white/10 pt-4 mt-4">
            <h3 className="text-sm font-bold uppercase tracking-wider text-muted-foreground mb-3">Test-E-Mail senden</h3>
            <div className="space-y-2">
              <Input
                type="email"
                placeholder="test@beispiel.at"
                value={testEmail}
                onChange={e => setTestEmail(e.target.value)}
                className="bg-input/50 border-white/10 rounded-none"
                data-testid="email-test-input"
              />
              <button
                onClick={sendTestEmail}
                disabled={sending || !testEmail}
                className="w-full px-4 py-2 bg-primary text-primary-foreground text-xs font-bold uppercase disabled:opacity-50"
                data-testid="email-test-send"
              >
                {sending ? "Wird gesendet..." : "Test senden"}
              </button>
            </div>
          </div>
        </div>

        <div className="lg:col-span-2">
          <h3 className="text-sm font-bold uppercase tracking-wider text-muted-foreground mb-3">Vorschau</h3>
          {loading ? (
            <div className="flex items-center justify-center h-96 border border-white/10">
              <div className="animate-spin w-8 h-8 border-2 border-primary border-t-transparent rounded-full" />
            </div>
          ) : (
            <div className="border border-white/10">
              <div className="bg-white/5 px-4 py-2 border-b border-white/10">
                <p className="text-xs text-muted-foreground">Betreff:</p>
                <p className="text-sm font-semibold">{previewSubject}</p>
              </div>
              <div className="h-[500px] overflow-auto">
                <iframe
                  srcDoc={previewHtml}
                  title="E-Mail Vorschau"
                  className="w-full h-full border-0"
                  sandbox="allow-same-origin"
                  data-testid="email-preview-iframe"
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
